import { AppData, Step } from "../../AppDataProvider";

import { CompleteLocationAvailabilityStepPayload } from "../../actions";
import { Mixpanel } from "../../../mixpanel";

export type CompleteLocationAvailabilityStepOptions = {
  appData: AppData;
  payload: CompleteLocationAvailabilityStepPayload;
};

export const completeLocationAvailabilityStep = (
  options: CompleteLocationAvailabilityStepOptions,
): AppData => {
  const { bookingData } = options.appData;
  const { organisation, service } = options.payload.updatedData;
  const { allowBookingNotes, externalBookingQuestions } = organisation;

  Mixpanel.track({
    name: "Completed step",
    props: { step: "locationAvailability" },
  });

  const getNextStep = (): Step => {
    const hasRelevantBookingQuestions = externalBookingQuestions.some(
      (question) =>
        !question.services ||
        question.services.map(({ _id }) => _id).includes(service._id),
    );

    if (allowBookingNotes || hasRelevantBookingQuestions) {
      return "bookingQuestions";
    }

    return "details";
  };

  const updatedBookingData = {
    ...bookingData,
    ...options.payload.updatedData,
  };

  return {
    ...options.appData,
    bookingData: updatedBookingData,
    currentStep: getNextStep(),
  };
};
